import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { icsIncidentLocationsKeys } from './icsIncidentLocation.queryKeys';
import { IcsIncidentLocation } from './icsIncidentLocation.types';
import { internalLayerVersionsKeys } from 'hooks/internalLayerVersion/queryKeys';
import { parseError } from 'hooks/shared/error';

export const useDeleteLocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      return await axios.delete<IcsIncidentLocation>(
        `${config.apiGateway.ics_locations}/${id}`
      );
    },
    onSuccess: () => {
      toast.success(`Location deleted`);
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: icsIncidentLocationsKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: internalLayerVersionsKeys.all(),
      });
    },
  });
};
